import { useState } from "react";
import ChevronLeftIcon from "../../../../assets/svg/ChevronLeftIcon";
import { useLocation, useNavigate } from "react-router-dom";

import ApplicationMessagesTab from "./components/ApplicationMessagesTab";
import ApplicationSkillsMatchtab from "./components/ApplicationSkillsMatchtab";
import ApplicationTrackerTab from "./components/ApplicationTrackerTab";
import ApplicationProfileTab from "./components/ApplicationProfileTab";

const JobApplicationDetail = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { member, jobData } = location.state || {};

  const tabs = [
    {
      title: "Skills Match",
      value: 0,
    },
    {
      title: "Profile",
      value: 1,
    },
    {
      title: "Tracker",
      value: 2,
    },
    {
      title: "Messages",
      value: 3,
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return <ApplicationSkillsMatchtab />;
      case 1:
        return (
          <ApplicationProfileTab profileDetails={{ ...member, jobData }} />
        );
      case 2:
        return (
          <ApplicationTrackerTab applicationTracker={{ ...member, jobData }} />
        );
      case 3:
        return (
          <ApplicationMessagesTab applicationDetails={{ ...member, jobData }} />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow px-6 py-2 overflow-hidden">
      <button
        // onClick={() => navigate("/network-detail", { state: member })}
        onClick={() =>
          navigate(`/network/${member?.candidateId}`, {
            state: member,
          })
        }
        className="flex items-center self-start my-3"
      >
        <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
        <label className="text-xs font-medium text-primary cursor-pointer">
          Back to listing
        </label>
      </button>

      <div className="flex items-center border-b border-gray-300 gap-16 mt-5 pb-2 pl-4">
        {tabs?.map((tab) => {
          const isActive = tab?.value === activeTab;
          return (
            <button
              key={tab?.value}
              onClick={() => setActiveTab(tab?.value)}
              className={`flex items-center ${
                isActive ? "border-b border-primary" : ""
              }`}
            >
              <span
                className={`text-xs pb-0.5 ${
                  isActive ? "text-primary font-medium" : "text-gray-500"
                }`}
              >
                {tab?.title}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex flex-col flex-1 w-full overflow-y-auto no-scrollbar mt-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default JobApplicationDetail;
